var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"volume-icon",attrs:{"viewBox":"0 0 24 24"},on:{"click":_vm.toggle}},[_c('path',{attrs:{"fill":"white","d":_vm.d}})])}
var staticRenderFns = []

export { render, staticRenderFns }